import React, { useEffect, useState } from "react";
import http from "../../../services/http";
import BusinessLicenceReview from "../Partner/component/BusinessLicenceReview";

/** 01/11/2026 (Quân): chữ ký có họ tên lệch người được ký — chờ Admin duyệt rồi mới gửi chứng nhận. */
type Dong = { partnerId: number; partnerName: string; certCode: string; signerName: string; signedAt: string; expected?: string[] };

export default function HangChoChuKy() {
	const [ds, setDs] = useState<Dong[]>([]);
	const [mo, setMo] = useState<number | null>(null);
	const tai = () =>
		http
			.get("/admin/signature-reviews", { params: { status: "pending" } })
			.then(({ data }) => setDs(data?.data || []))
			.catch(() => setDs([]));
	useEffect(() => {
		tai();
	}, []);
	if (!ds.length) return null;
	return (
		<div data-testid="signature-queue" style={{ margin: "0 0 14px", padding: 12, background: "#FFFAEB", border: "1px solid #FEDF89", borderRadius: 10, fontSize: 13 }}>
			<strong>Signatures to check ({ds.length})</strong>
			<div style={{ color: "#475467", margin: "2px 0 6px" }}>
				The name signed does not match the representative or an authorised signer. The certificate is held until you
				approve; reject asks the station to sign again.
			</div>
			{ds.map((d) => (
				<div key={`${d.partnerId}-${d.certCode}`} style={{ borderTop: "1px solid #FEDF89", padding: "6px 0" }}>
					<div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
						<span style={{ flex: 1 }}>
							<strong>#{d.partnerId} {d.partnerName}</strong> · signed as <strong>{d.signerName}</strong>
							{d.expected?.length ? ` · expected ${d.expected.join(" / ")}` : ""} · {new Date(d.signedAt).toLocaleString()}
						</span>
						<button
							type="button"
							onClick={() => setMo(mo === d.partnerId ? null : d.partnerId)}
							style={{ border: "1px solid #D0D5DD", background: "#fff", borderRadius: 8, padding: "4px 10px", cursor: "pointer" }}>
							{mo === d.partnerId ? "Close" : "Open"}
						</button>
					</div>
					{mo === d.partnerId ? <BusinessLicenceReview partnerId={String(d.partnerId)} open onChanged={tai} /> : null}
				</div>
			))}
		</div>
	);
}
